import { useSnackbar } from 'notistack';

import { useConfirmDialog } from 'contexts/ConfirmDialogContext';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';
import { removeQuoteAttachment } from 'store/slices/reconciliation';

export const useQuoteAttachments = () => {
  const dispatchAction = useAsyncDispatch();

  const { enqueueSnackbar } = useSnackbar();
  const { openConfirmDialog } = useConfirmDialog();

  const handleDeleteAttachment = (quoteId, attachmentId, callback = () => {}) => {
    if (!attachmentId) return;
    openConfirmDialog({
      title: `Delete Attachment`,
      text: `Are you sure you want to delete this attachment? Click 'Delete' to proceed.`,
      handler: () => {
        dispatchAction(removeQuoteAttachment({ quoteId, attachmentId }), {
          onSuccess: () => {
            enqueueSnackbar(`Attachment has been successfully deleted.`);
            callback();
            close();
          },
          errorFallback: 'Unable to delete attachment',
        });
      },
    });
  };

  return {
    handleDeleteAttachment,
  };
};
